import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=62607a76&scoped=true"
import script from "./SystemNotifications.vue?vue&type=script&lang=js"
export * from "./SystemNotifications.vue?vue&type=script&lang=js"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=62607a76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62607a76",
  null
  
)

export default component.exports